gs.component('apnComponent', {
    templateUrl: 'components/apn/apn.html',
    link: function (DI) {
        var _this = this;
        var type = this.type = DI.$attrs.type || 'apn';
        this.title = type === 'lok' ? 'Government contribution (LOK)' : 'Municipal contribution';
        this.hasPermission = DI.$rootScope.hasPermission;
        this.settings = null;
        this.staffnext = DI.$rootScope.staffnext;
        if (type === 'lok') {
            DI.server.get('/api/lok/setting/get').then(function (result) { return _this.settings = result; });
        }
        else {
            DI.Setting.get('apn').then(function (result) { return _this.settings = result; });
        }
        this.data = {};
        this.isValid = function () { return !!(_this.data.start && _this.data.end && _this.data.start <= _this.data.end); };
        this.result = [];
        this.loading = function () { return _this.loading.download || _this.loading.show || _this.loading.report; };
        this.downloadReport = function () {
            var link = "/api/lok/report/activity?start=".concat(_this.data.start.yyyymmdd(), "&end=").concat(_this.data.end.yyyymmdd());
            _this.loading.report = true;
            DI.fileManager.downloadFileFromServer(link)["finally"](function () {
                _this.loading.report = false;
            });
        };
        this.downloadXML = function () {
            var link = "/api/".concat(type, "/download?start=").concat(_this.data.start.yyyymmdd(), "&end=").concat(_this.data.end.yyyymmdd());
            _this.loading.download = true;
            DI.fileManager.downloadFileFromServer(link)["catch"](function (error) {
                DI.alertProvider.show('error', error && error.message || 'Error');
            })["finally"](function () {
                _this.loading.download = false;
            });
        };
        this.sendXML = function () {
            _this.loading.download = true;
            var data = Object.assign({}, _this.data);
            if (type == 'lok') {
                if (DI.$rootScope.currentStaff.superUser) {
                    data.force = confirm('Perform full sync?');
                }
                DI.server.post2("/api/lok/send", data).then(function () {
                    DI.alertProvider.show('success', 'Syncing are started now');
                })["catch"](function (error) {
                    DI.alertProvider.show('error', error.data && error.data.message || 'Error');
                })["finally"](function () {
                    _this.loading.download = false;
                });
            }
            else {
                DI.server.post2("/api/apn/send", data).then(function () {
                    var msg = DI.$filter('translate')('Activities up to {0} are submitted').replace('{0}', _this.data.end.yyyymmdd());
                    DI.alertProvider.show('success', msg);
                })["catch"](function (error) {
                    DI.alertProvider.show('error', error.data && error.data.message || 'Error');
                })["finally"](function () {
                    _this.loading.download = false;
                });
            }
        };
        this.fieldWorkoutTypes = {
            value: [],
            options: function () { return DI.$rootScope.workouttypes.filter(function (wt) { return wt.active; }); },
            getName: function (d) { return d.name; }
        };
        this.summaryReport = function () {
            _this.loading.report = true;
            DI.server.post2('/api/lok/summary', {
                start: _this.data.start,
                end: _this.data.end,
                workouttypes: _.pluck(_this.fieldWorkoutTypes.value, 'id')
            }, { download: true })["finally"](function () { return _this.loading.report = false; });
        };
        this.show = function () {
            if (_this.loading.show)
                return;
            _this.loading.show = true;
            _this.data.workouttypes = _.pluck(_this.fieldWorkoutTypes.value, 'id');
            DI.server.post2("/api/".concat(type, "/get_workouts"), _this.data).then(function (result) {
                _this.result = result;
                _this.config.control.update();
            })["finally"](function () { return _this.loading.show = false; });
        };
        var showThrottle = _.throttle(this.show, 3000);
        DI.live.subscribe({
            type: 'workout',
            scope: this,
            callback: function (workout) {
                if (!_this.isValid())
                    return;
                for (var _i = 0, _a = _this.result; _i < _a.length; _i++) {
                    var w = _a[_i];
                    if (w.id === workout.id) {
                        showThrottle();
                        break;
                    }
                }
            }
        });
        DI.live.subscribe({
            type: 'workoutbooking',
            scope: this,
            callback: function (wb) {
                if (!_this.isValid())
                    return;
                for (var _i = 0, _a = _this.result; _i < _a.length; _i++) {
                    var w = _a[_i];
                    if (w.id === wb.workout) {
                        showThrottle();
                        break;
                    }
                }
            }
        });
        DI.live.subscribe({
            type: 'workouttype',
            scope: this,
            callback: function () {
                if (!_this.isValid())
                    return;
                showThrottle();
            }
        });
        var checkWorkout = function (w) {
            DI.$modal.open({
                template: "<apn-check-workout workout-id=\"".concat(w.id, "\" type=\"").concat(type, "\"></apn-check-workout>")
            });
        };
        var showWorkout = function (w) {
            DI.workoutProvider.getWorkoutById(w.id).then(function (workout) {
                DI.$modal.open({
                    templateUrl: 'views/workout.html',
                    controller: 'WorkoutModalCtrl',
                    resolve: {
                        workout: function () {
                            return workout;
                        }
                    }
                });
            });
        };
        var getRemainingNotApproved = function (w) {
            return w.remainingNotApproved + ' ' + DI.$filter('translate')('of') + ' ' + w.bookings;
        };
        this.config = {
            getItems: function () { return _this.result; },
            rowClick: showWorkout,
            searchDepth: 2,
            countSuffixList: ['workout', 'workouts'],
            columns: [
                { field: 'startTime', title: 'Date', format: 'datetime' },
                { field: 'workoutType', title: 'Workout type' },
                { field: 'staff', title: 'Staff', getValue: function (w) { return w.staffs.map(function (userId) { return DI.$rootScope.getMember(userId).name; }).join(', '); } },
                { field: 'present', title: 'Present' },
                { field: 'bookings', title: 'Booked slots', getValue: function (w) { return w.space ? "".concat(w.bookings, "/").concat(w.space) : w.bookings; } },
                { field: 'remainingNotApproved', title: 'Not approved', getValue: getRemainingNotApproved, visible: function (c) { return c.name !== 'Approved' && type === 'lok'; } }
            ],
            orderColumn: 'startTime',
            buttons: [
                { title: 'Check', buttonClass: 'btn-info', onClick: checkWorkout, visible: function (r) { return r.group !== 2; } }
            ],
            tabs: [
                { name: 'Not approved', badgeClass: 'badge-danger', itemFilter: function (r) { return r.group == 0; } },
                { name: 'Partially approved', badgeClass: 'badge-warning', itemFilter: function (r) { return r.group == 1; } },
                { name: 'Approved', badgeClass: 'badge-success', itemFilter: function (r) { return r.group == 2; } }
            ]
        };
        DI.server.get("/api/".concat(type, "/get_period")).then(function (response) {
            if (!response || !response.from)
                return;
            _this.period = response;
            _this.data.start = _this.period.from;
            _this.data.end = _this.period.to;
            _this.sendDayDelay = getSendDayDelay(type);
        });
        function getSendDayDelay(type) {
            if (type === 'lok') {
                return "5";
            }
            else if (type === 'apn') {
                return "2";
            }
            else {
                return "1";
            }
        }
        var files = [];
        var reloadFiles = _.debounce(function () {
            DI.server.get("/api/".concat(type, "/get_files")).then(function (response) {
                files = response;
                _this.configFiles.control.update();
            });
        }, 100);
        DI.live.subscribe({
            type: type === 'apn' ? 'apnfile' : 'lokfile',
            scope: this,
            callback: function () {
                reloadFiles();
            }
        });
        reloadFiles();
        var showFile = function (file) {
            DI.$modal.open({
                template: "<lok-details id=\"".concat(file.id, "\" type=\"").concat(type, "\"></lok-details>")
            });
        };
        this.configFiles = {
            getItems: function () { return files; },
            countSuffixList: ['file', 'files'],
            columns: [
                { field: 'id', title: 'Id' },
                { field: 'created', title: 'Created', format: 'datetime' },
                { field: 'status', title: 'Status' },
                { field: 'summary', title: 'Summary', getValue: function (d) { return d.summary || d.title; } }
            ],
            buttons: [
                { title: 'Show', buttonClass: 'btn-info', onClick: showFile }
            ]
        };
    }
});
gs.component('apnCheckWorkout', {
    templateUrl: 'components/apn/apn-check-workout.html',
    link: function (DI) {
        var _this = this;
        var workoutId = Number(DI.$attrs['workoutId']);
        var type = DI.$attrs['type'];
        this.result = [];
        this.title = 'Workout';
        DI.workoutProvider.getWorkoutById(workoutId).then(function (w) {
            _this.title = w.workoutType.name;
            if (w.extra_title) {
                _this.title += ' - ' + w.extra_title;
            }
            _this.title += ", ".concat(w.startTime.yyyymmdd(), ", ").concat(w.startTime.hhmm(), " - ").concat(w.endTime.hhmm());
        });
        var firstLoading = true;
        var reload = function () {
            DI.server.get("/api/".concat(type, "/check_workout"), { workout_id: workoutId }).then(function (response) {
                var translate = DI.$filter('translate');
                response.forEach(function (i) {
                    if (i.user_id) {
                        var user = DI.$rootScope.getMember(i.user_id);
                        i.name = user.name + ': ' + i.fields.map(translate).join(', ');
                    }
                    else if (i.presence) {
                        i.name = translate('Need to set presence');
                    }
                    else if (i.workout_type_id) {
                        i.name = translate(i.type === 'type' ? 'Need to set type of activity for workout type' : 'Need to set sport for workout type');
                    }
                    else if (i.staff_required) {
                        i.name = translate('Need to add instructors');
                    }
                    else if (i.team_captain_required) {
                        i.name = translate('Need to add team captain');
                    }
                });
                _this.result = response;
                if (!firstLoading && !response.length)
                    _this.$parent.$close();
                firstLoading = false;
            });
        };
        reload();
        this.open = function (row) {
            if (row.user_id) {
                DI.util.showDataDialog({ controller: 'CustomerDataCtrl', item: DI.$rootScope.getMember(row.user_id) });
            }
            else if (row.presence) {
                DI.$modal.open({
                    templateUrl: 'views/attendance.html',
                    controller: 'AttendanceCtrl',
                    resolve: {
                        options: function () {
                            return {
                                workoutId: workoutId
                            };
                        }
                    }
                });
            }
            else if (row.workout_type_id) {
                var workoutType_1 = _.findWhere(DI.$rootScope.workouttypes, { id: row.workout_type_id });
                DI.$modal.open({
                    templateUrl: 'views/changemodal.html',
                    controller: 'WorkoutTypeChangeModalCtrl',
                    resolve: {
                        workoutType: function () {
                            return workoutType_1;
                        }
                    }
                });
            }
            else if (row.staff_required) {
                DI.workoutProvider.getWorkoutById(workoutId).then(function (w) {
                    var field = {
                        value: w.staffs,
                        itemTypes: ['staff', 'customer'],
                        change: function () {
                            console.log(field.value);
                            DI.$http.post('/api/schedule/workout/change', {
                                id: w.id,
                                Staffs: field.value.map(function (s) { return ({ id: s.id }); })
                            }).success(function () {
                                DI.alertProvider.show('success', 'Workout moved');
                            }).error(function () {
                                DI.alertProvider.show('error', 'Failed to move workout');
                            });
                        }
                    };
                    _this.$root.getCustomersForField(field);
                });
            }
            else if (row.team_captain_required) {
                DI.server.get('/api/teamsport/match/get_from_workout', { id: workoutId }).then(function (response) {
                    DI.server.get('/api/teamsport/match/get', { id: response.match_id, full: true }).then(function (match) {
                        var activity = match.team_activities.find(function (a) { return a.id === workoutId; });
                        var team = match.teams.find(function (t) { return activity.bookable_for_groups.includes(t.group.id); });
                        activity.bookings.forEach(function (b) {
                            b.user = DI.$rootScope.getMember(b.user_id);
                        });
                        DI.$modal.open({
                            templateUrl: 'views/changemodal.html',
                            controller: 'TeamCaptainCtrl',
                            resolve: {
                                match: function () {
                                    return match;
                                },
                                team: function () {
                                    return team;
                                },
                                bookings: function () {
                                    return activity.bookings;
                                }
                            }
                        });
                    });
                });
            }
        };
        DI.live.subscribe({
            type: 'workout',
            scope: this,
            callback: function (w) {
                if (w.id === workoutId)
                    reload();
            }
        });
        DI.live.subscribe({
            type: 'workoutbooking',
            scope: this,
            callback: function (wb) {
                if (wb.workout === workoutId)
                    reload();
            }
        });
        DI.live.subscribe({
            type: 'user',
            scope: this,
            callback: function (user) {
                for (var _i = 0, _a = _this.result; _i < _a.length; _i++) {
                    var row = _a[_i];
                    if (row.user_id === user.id) {
                        reload();
                        return;
                    }
                }
            }
        });
        DI.live.subscribe({
            type: 'workouttype',
            scope: this,
            callback: function (wt) {
                for (var _i = 0, _a = _this.result; _i < _a.length; _i++) {
                    var row = _a[_i];
                    if (row.workout_type_id === wt.id) {
                        reload();
                        return;
                    }
                }
            }
        });
    }
});
gs.component('lokDetails', {
    templateUrl: 'components/apn/lok_details.html',
    link: function (DI) {
        var _this = this;
        this.items = null;
        this.details = null;
        var type = DI.$attrs.type;
        var reload = function () {
            DI.server.get("/api/".concat(type, "/get_files"), { id: DI.$attrs.id }).then(function (response) {
                if (type === 'apn') {
                    _this.items = response.details.items.map(function (d) {
                        return {
                            id: d.id,
                            link_type: d.feltyp,
                            status: d.feltyp,
                            info: d.info
                        };
                    });
                    _this.details = response.details.details && response.details.details.replace(/\n/g, '<br/>');
                }
                else {
                    _this.items = response.response.items.map(function (d) {
                        var link;
                        if (d.type === 'activity')
                            link = DI.Link('workout', d.id);
                        return {
                            link: link,
                            id: d.id,
                            link_type: d.type == 'activity' ? 'workout' : d.type,
                            status: d.status,
                            name: d.name,
                            info: d.info
                        };
                    });
                    _this.details = response.title;
                }
            });
        };
        reload();
        this.open = function (item) {
            if (item.link.type == 'workout') {
                DI.workoutProvider.getWorkoutById(item.link.id).then(function (w) {
                    DI.$modal.open({
                        templateUrl: 'views/workout.html',
                        controller: 'WorkoutModalCtrl',
                        resolve: {
                            workout: function () {
                                return w;
                            }
                        }
                    });
                });
            }
        };
    }
});
